<href [link]="component.cta_link">
    <div class="image-component overflow-hidden"
         [ngClass]="[component.ratio || '']">
        <img class="rf"
             [image]="component.image">
    </div>
</href>
